// import React from "react";
// import "../assets/css/App.css";
// import "../assets/css/Bootstrap.css";

// const Inputbox = ({
//   label,
//   type = "text",
//   placeholder,
//   onChange,
//   className,
//   id,
//   disabled,
//   maxLength,
//   readOnly,
//   role,
//   value,  // Accept value from parent
//   checked = false
// }) => {
//   return (
//     <>
//       {label && <label>{label}</label>}
//       <input
//         type={type}
//         value={value || ""}  // Use parent's value, fallback to empty string
//         placeholder={placeholder}
//         className={className}
//         id={id}
//         onChange={(e) => onChange && onChange(e)} // Ensure event is passed
//         maxLength={maxLength}
//         role={role}
//         readOnly={readOnly}
//         disabled={disabled}
//         checked={checked}  // Accept checked from parent
//       />
//     </>
//   );
// };

// export default Inputbox;
import React from "react";
import "../assets/css/App.css";
import "../assets/css/Bootstrap.css";

const Inputbox = ({
  label,
  type = "text",
  placeholder,
  onChange,
  className = "",
  id,
  disabled,
  maxLength,
  readOnly,
  role,
  value,
  checked = false,
  // New props for file inputs
  fileName,
  accept
}) => {
  // File input case
  if (type === "file") {
    return (
      <div className="file-input-wrapper m-0">
        {label && <label htmlFor={id}>{label}</label>}
        <div className="file-input-container">
          <input
            type="file"
            className={`form-control-file ${className}`}
            id={id}
            onChange={onChange}
            // disabled={disabled}
            accept={accept}
          />
          {/* <span className="file-input-label">
            {fileName || placeholder || "Choose file"}
          </span> */}
        </div>
      </div>
    );
  }

  // Textarea case (if you need it)
  if (type === "textarea") {
    return (
      <>
        {label && <label htmlFor={id}>{label}</label>}
        <textarea
          placeholder={placeholder}
          className={`form-control ${className}`}
          id={id}
          onChange={onChange}
          maxLength={maxLength}
          role={role}
          readOnly={readOnly}
          disabled={disabled}
          value={value || ""}
        />
      </>
    );
  }

  // All other input types
  return (
    <>
      {label && <label htmlFor={id}>{label}</label>}
      <input
        type={type}
        value={value || ""}
        placeholder={placeholder}
        className={`form-control ${className}`}
        id={id}
        onChange={onChange}
        maxLength={maxLength}
        role={role}
        readOnly={readOnly}
        disabled={disabled}
        checked={checked}
      />
    </>
  );
};

export default Inputbox;
